package com.karyadina.model

data class FlashcardPreset(
    val id: String,
    val name: String,
    val description: String,
    val examType: ExamType,
    val subjects: List<PresetSubject>
)

data class PresetSubject(
    val name: String,
    val color: String,
    val units: List<String>
)

object FlashcardPresets {
    /**
     * Preset 1: Study Planning with Flashcards
     * Shows how to use both Study Planner and Flashcards together
     */
    val STUDY_WITH_FLASHCARDS = FlashcardPreset(
        id = "study_flashcards",
        name = "Study Planning + Flashcards",
        description = "Combine study sessions with flashcard reviews. Perfect for structured exam prep.",
        examType = ExamType.OTHER,
        subjects = listOf(
            PresetSubject(
                "Math Concepts",
                "#4CAF50",
                listOf("Algebra", "Calculus", "Geometry", "Statistics")
            ),
            PresetSubject(
                "Science Topics",
                "#2196F3",
                listOf("Physics", "Chemistry", "Biology", "Environmental Science")
            ),
            PresetSubject(
                "Language Arts",
                "#FF9800",
                listOf("Grammar", "Vocabulary", "Literature", "Writing Skills")
            )
        )
    )

    /**
     * Preset 2: Simple Learning Flashcards
     * Just for flashcard-only learning without study planning
     */
    val SIMPLE_LEARNING = FlashcardPreset(
        id = "simple_learning",
        name = "Simple Learning Flashcards",
        description = "Quick and easy flashcard learning. No planning required, just learn!",
        examType = ExamType.OTHER,
        subjects = listOf(
            PresetSubject(
                "General Knowledge",
                "#9C27B0",
                listOf("History", "Geography", "Current Events", "Culture")
            ),
            PresetSubject(
                "Skills & Hobbies",
                "#00BCD4",
                listOf("Cooking", "Music", "Art", "Sports")
            ),
            PresetSubject(
                "Professional Development",
                "#E91E63",
                listOf("Leadership", "Communication", "Time Management", "Problem Solving")
            )
        )
    )

    val ALL_PRESETS = listOf(
        STUDY_WITH_FLASHCARDS,
        SIMPLE_LEARNING
    )

    fun getPresetsByExamType(examType: ExamType): List<FlashcardPreset> {
        return ALL_PRESETS.filter { it.examType == examType }
    }
}
